import Api from "js/core/api";
import isConnected from "./isConnected";
import { getStaticUrl } from "js/config";

const queueDispatch = {};
const queues = ["export", "assetResizer"];

let rendererUrl;

function getRendererUrl() {
    if (!rendererUrl) {
        const renderercssUrl = encodeURIComponent(getStaticUrl("/bundle/renderer.css", true));
        const rendererjsUrl = encodeURIComponent(getStaticUrl("/bundle/renderer.js", true));
        const vendorjsUrl = encodeURIComponent(getStaticUrl("/bundle/vendor.js", true));
        rendererUrl = `${window.location.origin}/renderer?renderercssUrl=${renderercssUrl}&rendererjsUrl=${rendererjsUrl}&vendorjsUrl=${vendorjsUrl}`;
    }

    return rendererUrl;
}

const send = (queue, data) => {
    if (!isConnected.connected) {
        return Promise.resolve();
    }

    if (window.isPlayer) {
        return Promise.reject(new Error("Player trying to add task to queue."));
    }

    data.queueName = queue;

    // export task needs renderer details for backwards compatability
    if (queue !== "assetResizer") {
        data.rendererUrl = getRendererUrl();
    }

    return Api.queue.post(data);
};

queues.forEach(queue => {
    queueDispatch[queue] = {
        send: data => {
            return send(queue, data);
        }
    };
});

export default queueDispatch;
